import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { useT } from '@hooks';
import label from './img/label.png';
import { appStore } from '@store';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 6px;
	margin-bottom: 20px;
`;

const PreviosText = styled.p`
	color: #808080;
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
	text-decoration: line-through;

	span {
		font-weight: 700;
		background: conic-gradient(
			from 0deg at 50% 50%,
			color(display-p3 0.0941 0.8235 0.6039) 4.820194132626057deg,
			color(display-p3 0.3608 0.9333 0.3529) 258.19480419158936deg
		);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
`;

const NewText = styled.div`
	border-radius: 5px;
	background: conic-gradient(
		from 0deg at 50% 50%,
		rgba(0, 214, 150, 0.18) 4.820194132626057deg,
		rgba(0, 242, 58, 0.18) 258.19480419158936deg
	);
	padding: 16px;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;

	img {
		width: 38px;
		min-width: 38px;
	}

	p {
		color: ${({ theme }) => theme.colors.text5};
		font-size: 18px;
		font-weight: 600;
		line-height: 21px;
	}
`;

export const Discount: FC = () => {
	const { T } = useT();
	const { fixedDiscountPercent, product: paymentModel, isOldFixedPrice } = appStore.paymentStore;
	const { pilatesV2, pilatesV3, pilatesV4, pilatesV5 } = appStore.paymentStore.settings;
	const { details: productDetails, name: product } = paymentModel;
	const price = productDetails?.intro_amount ?? productDetails?.amount ?? 0;
	let discount = productDetails?.oldPrice ? productDetails.oldPrice - productDetails.amount : 9.99;
	const previousDiscountData: Record<string, number> = {
		'59.99': 22,
		'21.99': 20,
		'29.99': 20,
	};

	const previousDiscountDataV2: Record<string, number> = {
		'59.99': 29,
		'21.99': 40,
		'29.99': 50,
	};

	const previousDiscountDataV3: Record<string, number> = {
		'59.99': 29,
		'21.99': 83,
		'29.99': 50,
	};

	const previousDiscountDataV4: Record<string, number> = {
		'59.99': 11,
		'21.99': 20,
		'29.99': 25,
	};

	const previousDiscount = useMemo(() => {
		const introAmount = paymentModel.details?.intro_amount;
		const amount = paymentModel.details?.amount;

		if (introAmount && amount) {
			if (paymentModel?.details?.trial_period_days === 7) {
				return 40;
			} else {
				return Math.round(((amount - introAmount) * 100) / amount);
			}
		} else {
			if (pilatesV2) {
				return previousDiscountDataV2[price] || 20;
			} else if (pilatesV3) {
				return previousDiscountDataV3[price] || 20;
			} else if (pilatesV4) {
				return previousDiscountDataV4[price] || 20;
			} else if (pilatesV5) {
				return previousDiscountDataV4[price] || 20;
			} else {
				return previousDiscountData[price] || 20;
			}
		}
	}, [paymentModel]);

	if (isOldFixedPrice && productDetails) {
		discount = isOldFixedPrice - productDetails.amount;
	}

	if (isOldFixedPrice && productDetails?.intro_amount) {
		discount = isOldFixedPrice - productDetails?.intro_amount;
	}

	const save = Math.round(((+price + discount - +price) / (+price + discount)) * 100) || 61;

	return (
		<Container>
			<PreviosText>
				Previous discount: <span>{previousDiscount}%</span>
			</PreviosText>
			<NewText>
				<img src={label} alt='' />
				<p>Get your personal plan with up to {save}% discount</p>
			</NewText>
		</Container>
	);
};
